import { render, staticRenderFns } from "./ChargeCard.vue?vue&type=template&id=70dea81e&"
import script from "./ChargeCard.vue?vue&type=script&lang=js&"
export * from "./ChargeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports